import { MatTabGroup } from '@angular/material/tabs';
import { Component, HostListener, inject, Injector, OnInit, viewChild, ChangeDetectionStrategy } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from '@angular/material/dialog';
import { JkEntityV2 } from '../../services/jkEntityV2';
import { JkBaseComponent } from '../jkbase/jkbase.component';
import { MaterialModule } from '../../material.module';
import { FormsModule } from '@angular/forms';
import { idNameItem, jkRestReturn } from '../../services/jkInterface';
import { jkLib } from '../../services/jkCommon';
import { JkComboboxComponent } from '../jkcombobox/jkcombobox.component';
import { JktextareaComponent } from '../jktextarea/jktextarea.component';

export const qbeCompare: idNameItem[] = [
  { id: '=', name: '等於', ps1: ' = ' },
  { id: '<', name: '小於', ps1: ' < ' },
  { id: '<=', name: '小於等於', ps1: ' <= ' },
  { id: '>=', name: '大於等於', ps1: ' >= ' },
  { id: '>', name: '大於', ps1: ' > ' },
  { id: 'like%', name: '前包含', ps1: ' like% ' },
  { id: '%like%', name: '其中包含', ps1: ' %like% ' },
  { id: '%like', name: '後包含', ps1: ' %like ' },
];

export class QbeConfig {
  title: string = '查詢條件設定';
  masterSrv: any;
  addField: string = '';
  addWhere: string = '';
  oldParam!: any;
  result: boolean = true;
}
/* 改內建到 jkSingle
export function doQbe<T>(
  //injector: Injector,
  tableSrv: JkEntityV2,
  addField: string
) {
  let boolRet: boolean = false;
  //const dialog = injector.get(MatDialog);
  let myRet: jkRestReturn = new jkRestReturnClass();
  myRet.obj = {
    title: '查詢條件設定',
    masterSrv: tableSrv,
    addField: addField,
    result: true,
  };
  const dialogRef = page.dialog.open(JkqbeComponent<T>, {
    width: '720px',
    height: '500px',
    data: myRet, // { title: '查詢條件設定', masterSrv: tableSrv, addField:addField,result: true }
  });
  return dialogRef.afterClosed();
}
  */
class paramItem {
  fieldId: string = '';
  fieldName: string = '';
  compare: string = 'like%';
  value: string = '';
  dataType: string = 'string';
}
@Component({
  selector: 'app-jkqbe',
  standalone: true,
  imports: [MaterialModule, FormsModule,JkComboboxComponent,JktextareaComponent ],
  templateUrl: './jkqbe.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './jkqbe.component.scss',
})
export class JkqbeComponent<T> extends JkBaseComponent implements OnInit {
  dialogRef = inject<MatDialogRef<JkqbeComponent<T>>>(MatDialogRef);
  dataRest = inject(MAT_DIALOG_DATA);

  override comType: string = 'jkqbe';
  readonly tabGroup = viewChild.required<MatTabGroup>('myTabGroup');
  @HostListener('document:keydown', ['$event'])
  async handleKeyboardEvent(event: KeyboardEvent) {
    if (event.key === 'Escape') {
      let bool = await this.page.showConfirm('','確定要離開?');//(orm.page as BasePage)
      if(bool){
        this.doCancel(event);
      }
    }
  }
  andOr: string = 'AND';
  tableSrv: JkEntityV2;
  addField: string = '';
  uiWhere: string = '';
  compareList = qbeCompare;
  paramList: paramItem[] = [];
  advParamList: idNameItem[] = [];
  advField: string = '';
  advCompare: string = 'like%';
  advValue: string = '';
  //jkRet: jkRestReturn;
  displayedColumns: string[] = ['fieldName', 'compare', 'value'];
  sqlWhere: string = '';
  sqlOrder: string = '';
  get tableName(): string {
    return this.tableSrv.tableName;
  }
  //public dataRest: any= inject(MAT_DIALOG_DATA);
  constructor() {
    super();
    let data = this.dataRest.obj;
    this.label.set(data.title);
    this.tableSrv = data.masterSrv;
    this.addField = data.addField;
    //this.jkRet = data.jkRet;
    this.addParamList(this.tableSrv.keyFields);
    let list = this.addField.split(',');
    this.addParamList(list);
    this.geneAdvParamList();
  }
  addParamList(list: string[]) {
    for (let i = 0; i < list.length; i++) {
      let key = list[i];
      let item = new paramItem();
      item.fieldId = key;
      item.fieldName = (this.tableSrv.columnLabel as any)[key];
      let fieldDef = jkLib.fixString(this.tableSrv.columnDefs.find(
        (x) => x.field === key
      )?.cellDataType);
      item.dataType = fieldDef ? fieldDef : 'string';
      this.paramList.push(item);
    }
  }
  geneAdvParamList() {
    let list = this.tableSrv.columnDefs;
    for (let i = 0; i < list.length; i++) {
      let item = list[i];
      let key = item.field || '';
      let fieldDef = item.cellDataType ;
      let dataType = jkLib.fixString(fieldDef ? fieldDef : 'string');
      let param: idNameItem = { id: key, name: item.headerName||'', ps1: dataType };
      if (i === 0) {
        this.advField = key;
        //this.advCompare = '=';
        //this.advValue = '';
      }
      this.advParamList.push(param);
    }
  }
  override ngOnInit() {
    super.ngOnInit();
  }
  // compare2Sql(
  //   xCompare: string,
  //   fieldId: string,
  //   dataType: string,
  //   value: string
  // ): string {
  //   let ret = '';
  //   let compare = xCompare;
  //   let compareStr = compare;
  //   if (compare === '%like') {
  //     compareStr = ' like ';
  //     value = "'%" + value + "'";
  //     ret = ' (' + fieldId + compareStr + value + ') ';
  //   } else if (compare === '%like%') {
  //     compareStr = ' like ';
  //     value = "'%" + value + "%'";
  //     ret = ' (' + fieldId + compareStr + value + ') ';
  //   } else if (compare === 'like%') {
  //     compareStr = ' like ';
  //     value = "'" + value + "%'";
  //     ret = ' (' + fieldId + compareStr + value + ') ';
  //   } else {
  //     if (dataType === 'string' || dataType === 'text') {
  //       value = "'" + value + "'";
  //     }
  //     ret = ' (' + fieldId + ' ' + compareStr + ' ' + value + ') ';
  //   }
  //   return ret;
  // }
  doOk(e: any) {
    this.sqlWhere = '';
    this.sqlOrder = '';
    const tabGroup = this.tabGroup();
    if(!tabGroup){
      alert('tabGroup is null');
      return;
    }
    if (tabGroup.selectedIndex === 0) {
      for (let i = 0; i < this.paramList.length; i++) {
        let item = this.paramList[i];
        let value: string = item.value;
        let fieldId: string = this.tableName + '.' + item.fieldId;
        if (item.value !== '') {
          this.sqlWhere += ' AND ';
          /*
          let compare = item.compare;
          let compareStr = compare;
          if (compare === '%like') {
            compareStr = ' like ';
            value = "'%" + item.value + "'";
            this.sqlWhere += ' (' + fieldId + compareStr + item.value + ') ';
          } else if (compare === '%like%') {
            compareStr = ' like ';
            value = "'%" + item.value + "%'";
            this.sqlWhere += ' (' + fieldId + compareStr + item.value + ') ';
          } else if (compare === 'like%') {
            compareStr = ' like ';
            value = "'" + item.value + "%'";
            this.sqlWhere += ' (' + fieldId + compareStr + item.value + ') ';
          } else {
            if (item.dataType === 'string' || item.dataType === 'text') {
              value = "'" + item.value + "'";
            }
            this.sqlWhere +=
              ' (' + fieldId + ' ' + compareStr + ' ' + item.value + ') ';
          }*/
          let tmpWhere = jkLib.compare2Sql(item.compare, fieldId, item.dataType, value);
          this.sqlWhere += tmpWhere;
        }
      }
    }
    if(tabGroup.selectedIndex === 1){
      this.sqlWhere = this.uiWhere;
    }
    let obj = {
      result: true,
      sqlWhere: this.sqlWhere,
      sqlOrder: this.sqlOrder,
    };
    this.dialogRef.close(obj);
  }
  doCancel(e: any) {
    let obj = {
      result: false,
      sqlWhere: this.sqlWhere,
      sqlOrder: this.sqlOrder,
    };
    this.dialogRef.close(obj);
  }
  elementValueChange($event: string) {
    console.log($event);
  }
  doClear() {
    this.uiWhere = '';
  }
  doAdd() {
    let ndx = this.advParamList.findIndex((x) => x.id === this.advField);
    if (ndx < 0) {
      return;
    }
    let tmpValue = this.advValue;
    let dataType = this.advParamList[ndx].ps1;
    if(!dataType ){
      dataType = 'string';
    }
    let temp = jkLib.compare2Sql(this.advCompare, this.advField, dataType, tmpValue);
    this.uiWhere += ' ' + this.andOr + ' ' + temp;
  }
  valueChange($event: Event) {
    this.advValue = ($event.target as HTMLInputElement).value;
  }

}
